import { useSearchPageFilters } from "@faire/retailer-visitor-shared/views/search-v2/SearchPageQueryParams/useSearchPageFilters";
import { useSearchPageIsFromDiscoverURL } from "@faire/retailer-visitor-shared/views/search-v2/SearchPageQueryParams/useSearchPageIsFromDiscoverURL";
import { useSearchPageProductSearchString } from "@faire/retailer-visitor-shared/views/search-v2/SearchPageQueryParams/useSearchPageProductSearchString";
import { useSearchPageQueryParams } from "@faire/retailer-visitor-shared/views/search-v2/SearchPageQueryParams/useSearchPageQueryParams";
import { useSearchPageZeroIndexedPageNumber } from "@faire/retailer-visitor-shared/views/search-v2/SearchPageQueryParams/useSearchPageZeroIndexedPageNumber";
import { route as filterRoute } from "@faire/web-api--source/api/v3/search/products/filters/post";
import { route as searchRoute } from "@faire/web-api--source/api/v3/search/products/post";
import { FilterSplitStrategy } from "@faire/web-api--source/indigofair/data/FilterSplitStrategy";
import { useMemo } from "react";

export const useSearchPageQueryQueryKey = (pageNumParam?: number) => {
  const query = useSearchPageProductSearchString();
  const filters = useSearchPageFilters();
  const pageNumber = useSearchPageZeroIndexedPageNumber();
  const { referrerType, refReqId, doQuerySpellCheck } =
    useSearchPageQueryParams();
  const isFromDiscoverURL = useSearchPageIsFromDiscoverURL();

  return useMemo(
    () => [
      searchRoute,
      FilterSplitStrategy.PRODUCTS_ONLY,
      query,
      filters,
      pageNumParam ?? pageNumber,
      referrerType,
      refReqId,
      doQuerySpellCheck,
      isFromDiscoverURL,
    ],
    [
      query,
      filters,
      pageNumParam,
      pageNumber,
      referrerType,
      refReqId,
      doQuerySpellCheck,
      isFromDiscoverURL,
    ]
  );
};

export const useSearchPageFiltersQueryQueryKey = () => {
  const query = useSearchPageProductSearchString();
  const filters = useSearchPageFilters();
  const { referrerType, refReqId, doQuerySpellCheck } =
    useSearchPageQueryParams();
  const isFromDiscoverURL = useSearchPageIsFromDiscoverURL();

  return useMemo(
    () => [
      filterRoute,
      FilterSplitStrategy.AGGREGATIONS_ONLY,
      query,
      filters,
      referrerType,
      refReqId,
      doQuerySpellCheck,
      isFromDiscoverURL,
    ],
    [
      doQuerySpellCheck,
      filters,
      query,
      refReqId,
      referrerType,
      isFromDiscoverURL,
    ]
  );
};
